import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDevelopmentPath } from "@core/schema/paths/getDevelopmentPath.js";

export function getHowWeDoIntegrations(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: `Nejprve zjistíme, jaké systémy ve firmě používáte a u kterých požadujete integraci. Rádi vám dáme doporučení a pomůžeme udělat důležitá rozhodnutí. sp[[Propojení systémů a aplikací samozřejmě řešíme i v rámci [${getDevelopmentPath(tenant)}][[vývoje na míru]]]].`,
		},
		{
			desc: "Jakmile si stanovíme cíle a odsouhlasíme cenovou nabídku, sp[[začneme na integraci pracovat.]]",
		},
		{
			desc: "sp[[Provedeme testování a výsledné řešení vám představíme.]] Pokud to bude potřeba, doladíme poslední detaily na základě vašich požadavků.",
		},
		{
			desc: "sp[[Spustíme integrované systémy do ostrého provozu,]] předáme vám dokumentaci a případně zaškolíme váš tým.",
		},
	];
}
